/**
 * GJ Cart Sidebar JS
 * Handles hover opening, AJAX updates, and sidebar logic
 */

class GJCartSidebar {
    constructor() {
        this.selectors = {
            sidebar: '.gj-cart-sidebar',
            overlay: '.gj-cart-sidebar-overlay',
            trigger: '.gj-header__icon-link[href$="/cart"]',
            closeBtn: '.gj-cart-sidebar__close',
            itemsContainer: '.gj-cart-sidebar__items',
            subtotal: '.gj-subtotal-value',
            progressBar: '.gj-progress-bar',
            shippingMsg: '.gj-shipping-msg'
        };

        this.sidebar = document.querySelector(this.selectors.sidebar);
        this.overlay = document.querySelector(this.selectors.overlay);
        this.triggers = document.querySelectorAll(this.selectors.trigger);
        this.closeBtn = document.querySelector(this.selectors.closeBtn);

        // Config: Frete grátis — puxa do data-attribute definido no Liquid
        const shippingBar = document.querySelector('.gj-cart-shipping-bar');
        this.freeShippingThreshold = shippingBar ? parseInt(shippingBar.dataset.freeShippingThreshold, 10) : 0;

        if (this.sidebar) {
            this.init();
        }
    }

    init() {
        // Open on hover - only desktop
        if (window.innerWidth > 990) {
            this.triggers.forEach(trigger => {
                trigger.addEventListener('mouseenter', () => this.open());
            });

            // Close when mouse leaves sidebar area
            this.sidebar.addEventListener('mouseleave', (e) => {
                // Only close if not moving back to the trigger
                const related = e.relatedTarget;
                let isMovingToTrigger = false;
                this.triggers.forEach(t => { if (t.contains(related)) isMovingToTrigger = true; });

                if (!isMovingToTrigger) {
                    // Add a small delay for better UX
                    this.hoverTimeout = setTimeout(() => this.close(), 300);
                }
            });

            this.sidebar.addEventListener('mouseenter', () => {
                if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
            });
        }

        // Always navigate on click as requested
        this.triggers.forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                // No e.preventDefault() here, so it goes to /cart
            });
        });

        if (this.closeBtn) {
            this.closeBtn.addEventListener('click', () => this.close());
        }

        if (this.overlay) {
            this.overlay.addEventListener('click', () => this.close());
        }

        // Listen for add-to-cart events if the theme uses them
        document.addEventListener('cart:added', () => {
            this.refresh();
            this.open();
        });

        // Initial update of progress bar
        this.updateShippingProgress();
    }

    open() {
        this.sidebar.classList.add('active');
        this.overlay.classList.add('active');
        document.body.classList.add('overflow-hidden');
        if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
    }

    close() {
        this.sidebar.classList.remove('active');
        this.overlay.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
    }

    async removeItem(id) {
        const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: id, quantity: 0 })
        });

        if (response.ok) {
            this.refresh();
        }
    }

    // Altera a quantidade de uma linha do carrinho (qty 0 remove o item)
    async changeLine(line, qty) {
        if (qty < 0) qty = 0;
        const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: line, quantity: qty })
        });

        if (response.ok) {
            this.refresh();
        }
    }

    async refresh() {
        const response = await fetch('/cart?view=ajax');
        const html = await response.text();

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Update items container
        const newItems = doc.querySelector(this.selectors.itemsContainer);
        if (newItems && this.sidebar.querySelector(this.selectors.itemsContainer)) {
            this.sidebar.querySelector(this.selectors.itemsContainer).innerHTML = newItems.innerHTML;
        }

        // Update subtotal
        const newSubtotal = doc.querySelector(this.selectors.subtotal);
        if (newSubtotal && this.sidebar.querySelector(this.selectors.subtotal)) {
            this.sidebar.querySelector(this.selectors.subtotal).innerHTML = newSubtotal.innerHTML;
        }

        // Update cart count in header (atualiza TODOS os badges e mostra/esconde conforme a qtd)
        const newCount = doc.querySelector('[data-cart-count]');
        if (newCount) {
            const n = parseInt(newCount.innerText) || 0;
            document.querySelectorAll('.gj-header__cart-count, [data-cart-count]').forEach((badge) => {
                badge.innerText = newCount.innerText;
                badge.style.display = n > 0 ? '' : 'none';
            });
        }

        this.updateShippingProgress();
    }

    updateShippingProgress() {
        const subtotalEl = this.sidebar.querySelector(this.selectors.subtotal);
        if (!subtotalEl) return;

        const subtotalText = subtotalEl.innerText.replace(/[^0-9,]/g, '').replace(',', '.');
        const subtotal = parseFloat(subtotalText) * 100;

        const progress = Math.min((subtotal / this.freeShippingThreshold) * 100, 100);
        const progressBar = this.sidebar.querySelector(this.selectors.progressBar);
        const shippingMsg = this.sidebar.querySelector(this.selectors.shippingMsg);

        if (progressBar) {
            progressBar.style.width = progress + '%';
        }

        if (shippingMsg) {
            if (subtotal >= this.freeShippingThreshold) {
                shippingMsg.innerHTML = 'Seu pedido agora está com <strong>frete grátis!</strong>';
            } else {
                const remaining = (this.freeShippingThreshold - subtotal) / 100;
                const formattedRemaining = remaining.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
                shippingMsg.innerHTML = `Faltam apenas <strong>${formattedRemaining}</strong> para <strong>frete grátis</strong>`;
            }
        }
    }
}

// Initialize when ready
document.addEventListener('DOMContentLoaded', () => {
    window.gjCartSidebar = new GJCartSidebar();
});
